import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/politica-de-privacidad-qbd-group")({
  head: () => buildRouteHead("/es/politica-de-privacidad-qbd-group", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/politica-de-privacidad", replace: true });
  },
});
